export default {
      id: "txt_standart-usage",
      viewBox: "0 0 23 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_standart",
      toString: function () {
        return this.url;
      }
    }